var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIconPrograms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6667 0.84375H6.33333C3.03125 0.84375 0.34375 3.53125 0.34375 6.83333V15.1667C0.34375 18.4688 3.03125 21.1562 6.33333 21.1562H14.6667C17.9688 21.1562 20.6562 18.4688 20.6562 15.1667V6.83333C20.6562 3.53125 17.9688 0.84375 14.6667 0.84375ZM19.0938 15.1667C19.0938 17.6042 17.1042 19.5938 14.6667 19.5938H6.33333C3.89583 19.5938 1.90625 17.6042 1.90625 15.1667V6.83333C1.90625 4.39583 3.89583 2.40625 6.33333 2.40625H14.6667C17.1042 2.40625 19.0938 4.39583 19.0938 6.83333V15.1667Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0497 4.97917C10.8934 4.82292 10.6955 4.75 10.4976 4.75C10.2997 4.75 10.1017 4.82292 9.94549 4.97917L5.77882 9.14583C5.47674 9.44792 5.47674 9.94792 5.77882 10.25C6.0809 10.5521 6.5809 10.5521 6.88299 10.25L10.495 6.83327L14.1122 10.25C14.4142 10.5521 14.9142 10.5521 15.2163 10.25C15.5184 9.94792 15.5184 9.44792 15.2163 9.14583L11.0497 4.97917Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94548 17.539C10.1017 17.6953 10.2996 17.7682 10.4976 17.7682C10.6955 17.7682 10.8934 17.6953 11.0496 17.539L15.2163 13.3723C15.5184 13.0703 15.5184 12.5703 15.2163 12.2682C14.9142 11.9661 14.4142 11.9661 14.1121 12.2682L10.5002 15.6849L6.88297 12.2682C6.58089 11.9661 6.08089 11.9661 5.77881 12.2682C5.47673 12.5703 5.47673 13.0703 5.77881 13.3723L9.94548 17.539Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIconPrograms);
export default __webpack_public_path__ + "static/media/expand-icon-programs.50efd1937a8b79a0a31dcf690c69c84b.svg";
export { ForwardRef as ReactComponent };